import { useTranslation } from 'react-i18next'
import { OverlayTextEditor, InfoOverlayEditor } from './ImageSlotDetailFields'

interface SlotInstructionsPanelProps {
  prompt: string
  originalPrompt: string
  overlayText: string
  infoOverlay: string
  rerunsUsed: number
  onPromptChange: (v: string) => void
  onOverlayChange: (v: string) => void
  onInfoOverlayChange: (v: string) => void
}

export function SlotInstructionsPanel({
  prompt,
  originalPrompt,
  overlayText,
  infoOverlay,
  rerunsUsed,
  onPromptChange,
  onOverlayChange,
  onInfoOverlayChange,
}: SlotInstructionsPanelProps) {
  const { t } = useTranslation()
  const isModified = prompt !== originalPrompt

  return (
    <div className="flex flex-col gap-4">
      <div>
        <div className="flex items-center justify-between mb-1.5">
          <label className="block text-2xs uppercase tracking-wide text-neutral-500">
            {t('amazonListing.concept.instructions')}
          </label>
          {isModified && (
            <button
              type="button"
              onClick={() => onPromptChange(originalPrompt)}
              className="text-2xs text-orange-500 hover:text-orange-600 underline"
            >
              {t('amazonListing.concept.resetInstructions')}
            </button>
          )}
        </div>
        <textarea
          value={prompt}
          onChange={(e) => onPromptChange(e.target.value)}
          rows={9}
          className="w-full text-xs p-2.5 rounded-lg border border-neutral-300 dark:border-neutral-600 bg-white dark:bg-neutral-800 text-neutral-900 dark:text-neutral-100 font-mono resize-y"
        />
      </div>
      <OverlayTextEditor overlayText={overlayText} onChange={onOverlayChange} />
      <InfoOverlayEditor value={infoOverlay} onChange={onInfoOverlayChange} />
      <div className="bg-amber-50 dark:bg-amber-500/10 border border-amber-300 dark:border-amber-500/30 rounded-lg px-3 py-2 flex justify-between items-center">
        <span className="text-xs text-amber-600">
          {t('amazonListing.concept.costLabel')}
        </span>
        <span className="text-sm font-bold text-amber-600">
          {t('amazonListing.slots.creditsPerRerun')}
        </span>
      </div>
      <p className="text-2xs text-neutral-400 text-center">
        {t('amazonListing.concept.rerunsUsed', { used: rerunsUsed })}
      </p>
    </div>
  )
}
